"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityLinkedSelectFilter = void 0;
var react_1 = __importDefault(require("react"));
var entity_filter_1 = require("./entity-filter");
var input_select_1 = require("../components/forms/input-select");
var entityLinkedSelectFilter = function (args) {
  var context = args.context,
    name = args.name,
    _a = args.loadingPlaceholder,
    loadingPlaceholder = _a === void 0 ? 'Please wait...' : _a,
    entityTypeName = args.entityTypeName;
  var loading = context.loading,
    t = context.t,
    data = context.data,
    entities = context.entities,
    values = context.values;
  var pargs = (0, entity_filter_1.entityFilterArgs)(args);
  var selectEntityDefinition = entities[entityTypeName];
  // data arrives in  a complete bucket for all filters, so we need to extract just the part for this field
  // the GraphQL query sets these up as an alias under the name of the field, so we look there
  var dataForFilter = data && data[name];
  // unwrap results, since the query uses `list` endpoints
  var results = dataForFilter && dataForFilter.results || [];
  var sortResults = function (a, b) {
    var aValue = selectEntityDefinition.select.transform(a, __assign(__assign({}, context), {
      useSlugForValue: true
    })).label;
    var bValue = selectEntityDefinition.select.transform(b, __assign(__assign({}, context), {
      useSlugForValue: true
    })).label;
    return aValue.localeCompare(bValue, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  };
  // Sort results before transforming them into select options
  var sortedResults = __spreadArray([], __read(results), false).sort(sortResults);
  // use the transformer from select to create select options. This will unify everything nicely. 
  var selectOptions = sortedResults.map(function (item) {
    return selectEntityDefinition.select.transform(item, __assign(__assign({}, context), {
      useSlugForValue: true
    }));
  });
  return __assign(__assign({}, pargs), {
    placeholder: loading ? t(loadingPlaceholder) : pargs.placeholder,
    render: function (props) {
      return react_1.default.createElement(input_select_1.InputSelect, __assign({
        borderless: true
      }, props, {
        loading: loading,
        isMulti: pargs.isMulti,
        options: selectOptions
      }));
    }
  });
};
exports.entityLinkedSelectFilter = entityLinkedSelectFilter;